import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { updateGigApi } from "../../API/API"


function* updateGigSaga(action) {
    try {
        console.log('action', action)
        const response = yield call(updateGigApi, action.payload);
        yield put({ type: types.UPDATE_GIG_SUCCESS, payload: response.data });
        // Call onSuccess callback if provided
        if (action.payload.onSuccess && typeof action.payload.onSuccess === 'function') {
            action.payload.onSuccess();
        }
    } catch (error) {
        yield put({ type: types.UPDATE_GIG_FAILURE, error });
    }
}

export function* watchUpdateGigSaga() {
    yield takeEvery(types.UPDATE_GIG_REQUESTED, updateGigSaga);
}